import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import { getApiUrl, getDemoCredentials, isDemoMode } from '../../config/demoMode';

export default function Login() {
  const [kullaniciAdi, setKullaniciAdi] = useState('');
  const [sifre, setSifre] = useState('');
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  // Otel seçim aşaması
  const [otelSecimAsamasi, setOtelSecimAsamasi] = useState(false);
  const [otelSecimData, setOtelSecimData] = useState(null);

  const navigate = useNavigate();
  const { loginUser } = useAuth();
  const demoMode = isDemoMode();
  const demoCredentials = getDemoCredentials();
  const demoQuickLoginEnabled = demoMode && demoCredentials.username && demoCredentials.password;
  const apiUrl = getApiUrl();

  const handleLogin = async (e) => {
    e.preventDefault();
    setHata('');
    setYukleniyor(true);

    try {
      if (!apiUrl) {
        setHata('Demo API adresi yapılandırılmamış.');
        return;
      }
      const data = await login(kullaniciAdi, sifre);

      if (data?.demoExpired) {
        navigate('/demo-suresi-doldu');
      } else if (data?.otelSecimGerekli) {
        setOtelSecimData(data);
        setOtelSecimAsamasi(true);
      } else if (data?.personelId) {
        loginUser(data);
        navigate(data.firmaId ? '/kamp-amiri' : '/');
      } else {
        setHata('Kullanıcı adı veya şifre hatalı.');
      }
    } catch (err) {
      setHata('Sunucuya bağlanılamadı.');
    } finally {
      setYukleniyor(false);
    }
  };

  const handleOtelSec = async (otelId) => {
    setYukleniyor(true);
    setHata('');
    try {
      if (!apiUrl) {
        setHata('Demo API adresi yapılandırılmamış.');
        return;
      }
      const res = await fetch(`${apiUrl}/auth/otel-sec`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ personelId: otelSecimData.personelId, otelId })
      });
      const data = await res.json();
      if (data?.demoExpired) {
        navigate('/demo-suresi-doldu');
        return;
      }
      if (!res.ok) {
        setHata(data?.message || 'Otel seçimi başarısız.');
        return;
      }
      loginUser(data);
      navigate(data.firmaId ? '/kamp-amiri' : '/');
    } catch {
      setHata('Sunucuya bağlanılamadı.');
    } finally {
      setYukleniyor(false);
    }
  };

  if (otelSecimAsamasi && otelSecimData) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="bg-gray-800 rounded-2xl shadow-2xl p-6 sm:p-10 w-full max-w-md">
          <div className="text-center mb-8">
            <div className="bg-blue-600 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <span className="text-white text-2xl font-bold">O</span>
            </div>
            <h1 className="text-white text-2xl font-bold">Otel Seçin</h1>
            <p className="text-gray-400 text-sm mt-1">
              Merhaba {otelSecimData.adSoyad}, hangi otelle devam etmek istiyorsunuz?
            </p>
          </div>

          {hata && (
            <div className="bg-red-500/20 border border-red-500 text-red-400 text-sm rounded-lg px-4 py-3 mb-4">
              {hata}
            </div>
          )}

          <div className="space-y-3">
            {otelSecimData.oteller.map(otel => (
              <button
                key={otel.otelId}
                onClick={() => handleOtelSec(otel.otelId)}
                disabled={yukleniyor}
                className="w-full bg-gray-700 hover:bg-blue-600 disabled:opacity-50 text-white font-medium py-4 px-5 rounded-xl transition-colors duration-200 text-left flex items-center gap-3"
              >
                <div className="bg-blue-500/20 w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-blue-400 text-lg">🏨</span>
                </div>
                <span>{otel.ad}</span>
              </button>
            ))}
          </div>

          <button
            onClick={() => { setOtelSecimAsamasi(false); setOtelSecimData(null); }}
            className="w-full mt-4 text-gray-400 hover:text-gray-300 text-sm py-2 transition-colors"
          >
            Geri dön
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="bg-gray-800 rounded-2xl shadow-2xl p-6 sm:p-10 w-full max-w-md">

        <div className="text-center mb-8">
          <div className="bg-blue-600 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <span className="text-white text-2xl font-bold">O</span>
          </div>
          <h1 className="text-white text-2xl font-bold">Otel Yönetim</h1>
          <p className="text-gray-400 text-sm mt-1">{demoMode ? 'Demo panele giriş yapın' : 'Panele giriş yapın'}</p>
        </div>

        {demoMode && (
          <div className="bg-blue-500/15 border border-blue-500/40 text-blue-200 text-sm rounded-lg px-4 py-3 mb-4">
            Bu ortam demo verileriyle çalışır. Canlı otel verilerine bağlı değildir.
          </div>
        )}

        {hata && (
          <div className="bg-red-500/20 border border-red-500 text-red-400 text-sm rounded-lg px-4 py-3 mb-4">
            {hata}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="text-gray-300 text-sm mb-1 block">Kullanıcı Adı</label>
            <input
              type="text"
              value={kullaniciAdi}
              onChange={(e) => setKullaniciAdi(e.target.value)}
              placeholder="kullanici_adi"
              className="w-full bg-gray-700 text-white rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-500"
            />
          </div>
          <div>
            <label className="text-gray-300 text-sm mb-1 block">Şifre</label>
            <input
              type="password"
              value={sifre}
              onChange={(e) => setSifre(e.target.value)}
              placeholder="••••••••"
              className="w-full bg-gray-700 text-white rounded-lg px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-500"
            />
          </div>
          <button
            type="submit"
            disabled={yukleniyor}
            className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-800 disabled:cursor-not-allowed text-white font-semibold py-3 rounded-lg transition-colors duration-200"
          >
            {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
          {demoQuickLoginEnabled && (
            <button
              type="button"
              onClick={() => {
                setKullaniciAdi(demoCredentials.username);
                setSifre(demoCredentials.password);
              }}
              className="w-full bg-gray-700 hover:bg-gray-600 text-white font-semibold py-3 rounded-lg transition-colors duration-200"
            >
              Demo Bilgilerini Doldur
            </button>
          )}
        </form>

      </div>
    </div>
  );
}
